
export const getEmptyVariationValue = () => ({
    id: null,
    value: null
});